import { Alert, Button } from '@mui/material';

export interface LoadErrorProps {
  subject: string;
  consequence: string;
  // Left out where there is nothing to retry, such as a page that loads everything once.
  onRetry?: () => void;
}

export const LoadError = ({ subject, consequence, onRetry }: LoadErrorProps) => (
  <Alert
    severity="error"
    action={
      onRetry && (
        <Button
          color="inherit"
          size="small"
          onClick={onRetry}>
          Retry
        </Button>
      )
    }>
    {`Could not load ${subject}, so ${consequence}.`}
  </Alert>
);
